import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const CallToAction = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,   
    threshold: 0.3,     
  });
  return (
    <section id="call-action" className="call-action">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xxl-6 col-xl-7 col-lg-8 col-md-9">
            <div className="inner-content text-center text-white">
              <h2>
                What could we offers ?
              </h2>

              <p>
               We are a leading provider of hardware and software solutions, delivering reliable technology services  <br />that help businesses operate efficiently and grow with confidence.
              </p>

              <div className="row g-4 pt-3">
                {/* Happy Clients */}
                <div className="col-sm-6" ref={ref}>
                  <div className="d-flex rounded p-3 align-items-center" style={{ background: "rgba(255, 255,255, 0.1)" }}>
                    <i className="fa fa-home fa-3x text-white"></i>
                    <div className="ms-3">
                      <h2 className="text-white mb-0">
                        {inView ? (
                          <CountUp
                            start={0}
                            end={850}
                            duration={2.5}
                            separator=","
                          />
                        ) : (
                          0
                        )}
                        +
                      </h2>
                      <p className="text-white mb-0">Happy CLients</p>
                    </div>
                  </div>
                </div>

                {/* Years of Experience */}
                <div className="col-sm-6" ref={ref}>
                  <div className="d-flex rounded p-3 align-items-center" style={{ background: "rgba(255, 255,255, 0.1)" }}>
                    <i className="fa fa-tasks fa-3x text-white"></i>
                    <div className="ms-3">
                      <h2 className="text-white mb-0">
                        {inView ? (
                          <CountUp
                            start={0}
                            end={20}
                            duration={5.5}
                            separator=","
                          />
                        ) : (
                          0
                        )}
                        +
                      </h2>
                      <p className="text-white mb-0">Years of Experience</p>
                    </div>
                  </div>
                </div>

                {/* Staffs */}
                <div className="col-sm-6" ref={ref}>
                  <div className="d-flex rounded p-3 align-items-center" style={{ background: "rgba(255, 255,255, 0.1)" }}>
                    <i className="fa fa-user-tie fa-3x text-white"></i>
                    <div className="ms-3">
                      <h2 className="text-white mb-0">
                        {inView ? (
                          <CountUp
                            start={0}
                            end={25}
                            duration={5.5}
                            separator=","
                          />
                        ) : (
                          0
                        )}
                        +
                      </h2>
                      <p className="text-white mb-0">Number of Staffs</p>
                    </div>
                  </div>
                </div>

                {/* Project Complete */}
                {/* <div className="col-sm-6">
                  <div
                    className="d-flex rounded p-3 align-items-center"
                    style={{ background: "rgba(255, 255, 255, 0.1)" }}
                  >
                    <i className="fa fa-home fa-3x text-white"></i>
                    <div className="ms-3">
                      <h2 className="text-white mb-0">
                        <CountUp
                          start={0}
                          end={750}
                          duration={10.5}
                          separator=","
                        />
                        +
                      </h2>
                      <p className="text-white mb-0">Project Complete</p>
                    </div>
                  </div>
                </div> */}
                <div className="col-sm-6" ref={ref}>
                  <div className="d-flex rounded p-3 align-items-center" style={{ background: "rgba(255, 255,255, 0.1)" }}>
                    <i className="fa fa-check-circle fa-3x text-white"></i>
                    <div className="ms-3">
                      <h2 className="text-white mb-0">
                        {inView ? (
                          <CountUp
                            start={0}
                            end={750}
                            duration={2.5}
                            separator=","
                          />
                        ) : (
                          0
                        )}
                        +
                      </h2>
                      <p className="text-white mb-0">Project Complete</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Optional CTA */}
              {/*
              <div className="pt-4">
                <button className="btn btn-outline-light">
                  Get Started
                </button>
              </div>
              */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
